module.exports = __webpack_public_path__ + "static/img/p10.6c2df90.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/p10.jpg
// module id = 62
// module chunks = 1